import React from 'react'
import logo from './logo.svg';
import './App.css';
import './index.css'
import axios from "axios";
import FacilityCard from "./components/FacilityCard";
import {Col, Container, Row} from "react-grid-system";

function App() {

    const [latitude, setLatitude] = React.useState(0);
    const [longitude, setLongitude] = React.useState(0);
    const [facilities, setFacilities] = React.useState([])

    const instance = axios.create({
        baseURL: 'https://api.allshifts.app/open/',
        timeout: 1000000
    });

    React.useEffect(() => {
        navigator?.geolocation?.getCurrentPosition(function(position) {
            setLatitude(position.coords.latitude);
            setLongitude(position.coords.longitude);
        });
    }, [])


    React.useEffect( () => {
        instance.post('shifts?lat='+latitude+'&lng='+longitude, {
            distance:50,
            minPayRate:14,
            searchByState:true,
            showApShift:true,
            showEveningShift:true,
            showMorningShift:true,
            showNightShift:true,
            showPaShift:true,
            state:null
        })
        .then(function (response) {
            console.log(response);

            const data = response.data;

            for (const f of data) {
                let photos = [];
                for (let i = 0; i < f.pictureCount; i++) {
                    photos.push(
                       'https://aahcs-profiles.s3.amazonaws.com/client/' + f.facility_id + '/' + i
                    );
                }
                f.photos = photos;
            }

            console.log('Rendering Facilities: ', data);
            if(data.length > 9){
                data.pop();
            }
            setFacilities([...data]);
        })
        .catch(function (error) {
            console.log(error);
        });
    }, [latitude, longitude])

  return (
    <div className="App">
        <Container >
            <Row gutterWidth={12}>
            {facilities.map((facility, i) => {
                return (
                    <Col xs={12} sm={12} md={6} lg={4} style={{marginBottom:'12px'}}>
                        <FacilityCard onClick={(f)=>{
                            console.log('facility card click')
                            window.open('https://allshifts.app/login', '_blank')
                        }} key={'facility-'+i} facility={facility}></FacilityCard>
                    </Col>
                )
            })}
            </Row>
        </Container>
    </div>
  );
}

export default App;
